import { FieldValues } from "react-hook-form";

import { states } from "@covertree/consts";

import { FormAutocomplete, FormAutocompleteProps } from "../FormAutocomplete";

type Props<TValues extends FieldValues> = Omit<
  FormAutocompleteProps<TValues, string>,
  "options"
>;

export const FormStateField = <TValues extends FieldValues>(
  props: Props<TValues>
) => <FormAutocomplete {...props} options={states} />;
